import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useAuth } from '../../contexts/AuthContext';
import './LogoutButton.css';

/**
 * Reusable logout button component with error handling
 */
function LogoutButton({ 
  className = 'logout-btn',
  children = 'Logout',
  onLogoutComplete
}) {
  const { logout } = useAuth();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleLogout = async () => {
    try {
      setIsLoggingOut(true);
      
      await logout();

      if (onLogoutComplete) {
        onLogoutComplete();
      }
    } catch (err) {
      console.error('Logout button error:', err);
    } finally {
      setIsLoggingOut(false);
    }
  };

  return (
    <button
      className={`${className} ${isLoggingOut ? 'logging-out' : ''}`}
      onClick={handleLogout}
      disabled={isLoggingOut}
      aria-label={isLoggingOut ? 'Logging out' : (typeof children === 'string' ? children : 'Logout')}
    >
      {isLoggingOut ? 'Logging out...' : children}
    </button>
  );
}

LogoutButton.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  onLogoutComplete: PropTypes.func
};

export default LogoutButton;
